import { Route, Routes } from "react-router-dom";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminHome from "@/pages/admin/AdminHome";
import AdminOperations from "@/pages/admin/AdminOperations";
import AdminStores from "@/pages/admin/AdminStores";
import AdminCompetitors from "@/pages/admin/AdminCompetitors";
import AdminAds from "@/pages/admin/AdminAds";
import AdminJobs from "@/pages/admin/AdminJobs";
import AdminHealth from "@/pages/admin/AdminHealth";
import AdminWaitlistEmail from "@/pages/admin/AdminWaitlistEmail";
import AdminEmails from "@/pages/admin/AdminEmails";
import AdminAudit from "@/pages/admin/AdminAudit";

/**
 * Nested routes mounted under /admin/* by App.js.
 *
 * AdminGuard is applied OUTSIDE this component (in App.js) so the layout's
 * Toaster and shell remain mounted while subroutes change.
 */
export default function AdminRoutes() {
  return (
    <Routes>
      <Route element={<AdminLayout />}>
        <Route index element={<AdminHome />} />
        <Route path="operations" element={<AdminOperations />} />
        <Route path="stores" element={<AdminStores />} />
        <Route path="competitors" element={<AdminCompetitors />} />
        <Route path="ads" element={<AdminAds />} />
        <Route path="jobs" element={<AdminJobs />} />
        <Route path="emails" element={<AdminEmails />} />
        <Route path="audit" element={<AdminAudit />} />
        <Route path="health" element={<AdminHealth />} />
        <Route path="waitlist-email" element={<AdminWaitlistEmail />} />
      </Route>
    </Routes>
  );
}
